import React from "react";
import { withStyles, fade } from "@material-ui/core/styles";
import WaveLayout from "components/styled/layouts/WaveLayout";
import ContentSectionMaxWidth from "components/styled/contentSection/ContentSectionMaxWidth";
import BigCard from "components/styled/bigCard/BigCard";
import Button from "@material-ui/core/Button/Button";
import { useDispatch } from "react-redux";
import { loginSocial } from "./actions";
import { useAuth } from "./useAuth";
import CircularProgress from "@material-ui/core/CircularProgress";

const GmailButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText("#ef4837"),
    backgroundColor: "#ef4837",
    "&:hover": {
      backgroundColor: fade("#ef4837", 0.8),
    },
  },
}))(Button);

const SignIn: React.FC = () => {
  const dispatch = useDispatch();

  const { isLoading } = useAuth();

  return (
    <WaveLayout>
      <ContentSectionMaxWidth>
        <BigCard
          title="Ingresá con tu cuenta de MG"
          content={
            <div
              style={{
                display: "flex",
                flex: 1,
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {!isLoading && (
                <GmailButton
                  variant="contained"
                  color="secondary"
                  style={{ marginBottom: 8 }}
                  onClick={() => dispatch(loginSocial("google-oauth2"))}
                >
                  Gmail
                </GmailButton>
              )}
              {isLoading && (
                <div style={{ width: 60, alignSelf: "center" }}>
                  <CircularProgress color="secondary"/>
                </div>
              )}
            </div>
          }
        />
      </ContentSectionMaxWidth>
    </WaveLayout>
  );
};

export default SignIn;
